export default __webpack_public_path__ + "media/images/work_with_us/work_hero_sm-6caeb1ea3c37be43edfca83e4c471bcf.webp";